import type {AccessControls} from './typedef';
import type {IpRange} from 'src/openapi/admin/models/IpRange';


export const VALIDATION_ERRORS = {
    INVALID_IP: 'This field requires 4 numeric values from 0 to 255',
    INVALID_IP_RANGE: 'Start IP value can not be lower than end IP value',
    DUPLICATED_IP_RANGE: 'This IP range is already defined',
    INVALID_DOMAIN: 'Please enter a valid domain name',
    DUPLICATED_DOMAINS: 'This domain is already defined',
    INVALID_PROXY_LINK: 'Please enter a valid URL',
};

export const DEFAULT_IP_RANGE: IpRange = {start: '', end: '', web: false, mobile: false, microSite: false};

export const DEFAULT_ACCESS_CONTROLS: AccessControls = {
    ipRanges: [DEFAULT_IP_RANGE],
    domains: [''],
    proxy: '',
};
